/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

UpdateUserSettings.js

*/

// Main settings page form

window.addEventListener('load', () => {
  // delete old cookies
  const deleteOldPageCookies = () => {
    if (document.cookie.indexOf('paginationPref') !== -1) {
      const pastDate = new Date('1972-01-01');
      document.cookie = `paginationPref=; expires=${pastDate}`;
    }
  };

  if (document.querySelector('#settings-form')) {
    let form = document.querySelector('#settings-form');

    form.addEventListener('change', (event) => {
      // update demo
      updateDemoLink(event.target);

      // grab a couple things
      const url = '/settings/update';
      const csrftoken = appSettings.csrfToken;

      // get LPP radio buttons selection
      const lppSetting = () => {
        let lpp = false;
        for (let option of document.querySelectorAll('fieldset#lpp input')) {
          if (option.checked) {
            lpp = Number(option.value);
          }
        }

        return lpp;
      };

      // post body data
      const body = {
        links_per_page: lppSetting(),
        open_in_new_tab: form.open_in_new_tab.checked,
        single_line_mode: form.single_line_mode.checked,
        show_star: form.show_star.checked,
        show_category: form.show_category.checked,
        show_timestamp: form.show_timestamp.checked,
        show_relative_timestamp: form.show_relative_timestamp.checked,
        show_description: form.show_description.checked,
        show_tags: form.show_tags.checked,
      };

      // request options
      const options = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrftoken,
        },
      };

      const submitSuccess = (response) => {
        let input;
        let errorClass;

        if (response === true) {
          input = appSettings.notifications.settingsUpdate;
        } else {
          input = appSettings.notifications.failed;
          errorClass = 'error';
        }

        const updateNotification = new LLBrowserNotification(input, errorClass);
        updateNotification.showNotification();
      };

      // send request
      try {
        deleteOldPageCookies();

        return (result = fetch(url, options)
          .then((res) => (res.ok ? res.json() : {}))
          .then((res) =>
            res.data ? submitSuccess(res.data) : submitSuccess(false)
          ));
      } catch (e) {
        console.warn(e);
      }
    });
  }

  // Swap timestamps formats
  const switchTimestampFormat = (element) => {
    let utc = element.title;
    let initial = element.innerText;
    let relative = element.dataset.relative;

    if (utc === initial) {
      element.innerText = relative;
    } else {
      element.innerText = utc;
    }
  };

  // Toggles link header visibility
  const toggleLinkHeaderVisibility = () => {
    const star = document.querySelector('ul#linklist .star');
    const category = document.querySelector('ul#linklist .category');
    const header = document.querySelector('ul#linklist .link-header');
    if (
      star.classList.contains('hidden') &&
      category.classList.contains('hidden')
    ) {
      header.classList.add('hidden');
    } else {
      header.classList.remove('hidden');
    }
  };

  // Update demo classes
  const updateDemoClasses = (updates, form) => {
    if (updates.itemToUpdate === undefined || updates.newClass === undefined) {
      throw 'LLDemoUpdateError - settings items undefined';
    } else {
      // cases where `true` setting value adds the class
      if (updates.newClass !== 'hidden') {
        updates.setting.checked
          ? updates.itemToUpdate.classList.add(updates.newClass)
          : updates.itemToUpdate.classList.remove(updates.newClass);

        // cases where `false` setting value adds the class
      } else {
        !updates.setting.checked
          ? updates.itemToUpdate.classList.add(updates.newClass)
          : updates.itemToUpdate.classList.remove(updates.newClass);
      }

      // handle simple mode
      const simple =
        form.single_line_mode.checked &&
        !form.show_star.checked &&
        !form.show_category.checked &&
        !form.show_timestamp.checked &&
        !form.show_description.checked &&
        !form.show_tags.checked;

      if (simple === true) {
        document.querySelector('ul#linklist').classList.add('simple');
      } else {
        document.querySelector('ul#linklist').classList.remove('simple');
      }
    }
  };

  const updateDemoLink = (inputSetting) => {
    let form = document.querySelector('#settings-form');

    let updates = {
      setting: inputSetting,
      itemToUpdate: undefined,
      newClass: undefined,
    };

    // handle cases
    if (updates.setting.id === 'single_line_mode') {
      updates.itemToUpdate = document.querySelector('ul#linklist');
      updates.newClass = 'condensed';
    } else if (updates.setting.id === 'show_relative_timestamp') {
      updates.itemToUpdate = document.querySelector('.link-li .ts');
      updates.newClass = 'in-utc';
      switchTimestampFormat(updates.itemToUpdate);

      // hide things
    } else if (updates.setting.id === 'show_star') {
      updates.itemToUpdate = document.querySelector('.link-li .star');
      updates.newClass = 'hidden';
    } else if (updates.setting.id === 'show_category') {
      updates.itemToUpdate = document.querySelector('.link-li .category');
      updates.newClass = 'hidden';
    } else if (updates.setting.id === 'show_timestamp') {
      updates.itemToUpdate = document.querySelector('.link-li .ts');
      updates.newClass = 'hidden';
    } else if (updates.setting.id === 'show_description') {
      updates.itemToUpdate = document.querySelector('.link-li .description');
      updates.newClass = 'hidden';
    } else if (updates.setting.id === 'show_tags') {
      updates.itemToUpdate = document.querySelector('.link-li .tags');
      updates.newClass = 'hidden';
    }

    try {
      updateDemoClasses(updates, form);
      toggleLinkHeaderVisibility();
    } catch (e) {
      console.error(e);
    }
  };

  // Link Page Footer Pagination Preference

  if (document.querySelector('#pagination-pref ul')) {
    const pagPrefFooter = document.querySelector('#pagination-pref ul');

    pagPrefFooter.addEventListener('click', (event) => {
      if (event.target.classList.contains('pagPrefLink')) {
        event.preventDefault();

        // grab a couple things
        const pref = Number(event.target.innerText);
        const url = '/settings/pagination-pref';
        const csrftoken = appSettings.csrfToken;

        // update pref links
        let parent = event.target.parentNode;
        let previouslyActive = parent.parentNode.querySelector('.active');
        previouslyActive.classList.remove('active');
        previouslyActive.innerHTML = `
					<a href="" class="pagPrefLink">${previouslyActive.innerText}</a>
				`;
        parent.classList.add('active');
        parent.innerHTML = event.target.innerText;

        // post body data
        const pagPref = {
          p: pref,
        };

        // request options
        const options = {
          method: 'POST',
          body: JSON.stringify(pagPref),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrftoken,
          },
        };

        const refreshPage = () => {
          document.dispatchEvent(appSettings.customEvents.fetchReadyEvent);
        };

        try {
          deleteOldPageCookies();

          return (result = fetch(url, options)
            .then((res) => res.json())
            .then((res) =>
              typeof res.data === 'number' ? refreshPage() : console.warn('NaN')
            ));
        } catch (e) {
          console.warn(e);
        }
      }
    });
  }
});
